<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      img: 'interrogation_mark.svg',
      bgColor: 'primary',
      textColor: 'white',
      title: title,
    }"
    :quasar-props="{
      noEscDismiss: true,
      noBackdropDismiss: true,
    }"
  >
    <template #body>
      <slot />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: "",
      },
    },
    emits: ["update:open"],
    computed: {
      internalOpen: {
        get() {
          return this.open;
        },
        set() {
          this.$emit("update:open", false);
        },
      },
    },
  };
</script>
